/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import moment from "moment";
import { v7 as uuidv7 } from "uuid";
import Typography from "@mui/material/Typography";

import { weekdayHeader, weekdayLabel } from "../dayRangePickerStyles";

const WeekdayHeader = ({ language }: { language: string }) => {
  const localeData = moment.localeData(language);

  const weekStart = localeData.firstDayOfWeek();
  const labels = localeData
    .weekdaysMin()
    .map(label => label.charAt(0).toUpperCase());

  const rotatedLabels = [
    ...labels.slice(weekStart),
    ...labels.slice(0, weekStart)
  ];

  return (
    <div css={css(weekdayHeader)}>
      {rotatedLabels.map(label => (
        <Typography
          variant="body1Regular"
          key={uuidv7()}
          css={css(weekdayLabel)}
        >
          {label}
        </Typography>
      ))}
    </div>
  );
};

export default WeekdayHeader;
